<template>
    <vue-content-loading :height="200" preserveAspectRatio="none">
      <rect x="280" y="27" rx="4" ry="4" width="120" height="18" />
      <rect x="280" y="57" rx="4" ry="4" width="100" height="10" />
      <rect x="280" y="77" rx="4" ry="4" width="100" height="10" />
      <rect x="280" y="97" rx="4" ry="4" width="80" height="10" />
      <rect x="280" y="117" rx="4" ry="4" width="80" height="10" />
      <rect x="280" y="137" rx="4" ry="4" width="80" height="10" />
    </vue-content-loading>
  </template>
  
  <script>
  import { VueContentLoading } from "vue-content-loading"
  
  export default {
    name: "campaign-loading-skeleton",
    components: { VueContentLoading }
  }
  </script>
  
  <style scoped>
  </style>


// WEBPACK FOOTER //
// src/components/homebase/campaigns/CampaignLoadingSkeleton.vue